import dynamic from "next/dynamic";
import React from "react";

import { reloadOnceOnChunkError } from "@/features/v2/pages/reloadOnChunkError";

import RouteSwitchPageLoading from "./RouteSwitchPageLoading";
import { RouteSwitchPageProps } from "./types";

// Keeps the V2 renderer out of the bundle that Builder V1 pages download.
const V2Page = dynamic(() => reloadOnceOnChunkError(() => import("./Page")), {
    loading: RouteSwitchPageLoading,
});

const RouteSwitchPage: React.FC<RouteSwitchPageProps> = (props) => (
    <V2Page
        {...(props.categoryListings ? { categoryListings: props.categoryListings } : {})}
        currentLocale={props.currentLocale}
        {...(props.giftCardsContent ? { giftCardsContent: props.giftCardsContent } : {})}
        page={props.page}
        hideFooter={props.hideFooter}
        hideNavigation={props.hideNavigation}
        isIndexPage={props.isIndexPage}
        siteSettings={props.siteSettings}
        status={props.status}
        {...(props.shopBrands ? { shopBrands: props.shopBrands } : {})}
    />
);

export default RouteSwitchPage;
